import { $ } from "ng";

export const directives = {
  showTooltipOnTextOverflow: $timeout => ({
    restrict: "A",
    link(scope, element, attrs) {
      const el = element[0];
      scope.$watch(
        function() {
          return el.scrollWidth;
        },
        function() {
          const el = element[0];
          if (el.offsetWidth < el.scrollWidth) {
            //console.log('ellipsis is active for element', element);
            attrs.tooltipEnable = "true";
          } else {
            //console.log('ellipsis is NOT active for element', element);
          }
        }
      );
    }
  }),
  ngTextTruncate: (
    $compile,
    ValidationServices,
    CharBasedTruncation,
    WordBasedTruncation
  ) => ({
    restrict: "A",
    scope: {
      text: "=ngTextTruncate",
      charsThreshould: "@ngTtCharsThreshold",
      wordsThreshould: "@ngTtWordsThreshold",
      customMoreLabel: "@ngTtMoreLabel",
      customLessLabel: "@ngTtLessLabel"
    },
    controller($scope, $element, $attrs) {
      $scope.toggleShow = function() {
        $scope.open = !$scope.open;
      };

      $scope.useToggling = $attrs.ngTtNoToggling === undefined;
    },
    link($scope, $element, $attrs) {
      $scope.open = false;

      ValidationServices.failIfWrongThreshouldConfig(
        $scope.charsThreshould,
        $scope.wordsThreshould
      );

      const CHARS_THRESHOLD = parseInt($scope.charsThreshould);
      const WORDS_THRESHOLD = parseInt($scope.wordsThreshould);

      $scope.$watch("text", function() {
        $element.empty();

        if (CHARS_THRESHOLD) {
          if (
            $scope.text &&
            CharBasedTruncation.truncationApplies($scope, CHARS_THRESHOLD)
          ) {
            CharBasedTruncation.applyTruncation(
              CHARS_THRESHOLD,
              $scope,
              $element
            );
          } else {
            $element.append($scope.text);
          }
        } else {
          if (
            $scope.text &&
            WordBasedTruncation.truncationApplies($scope, WORDS_THRESHOLD)
          ) {
            WordBasedTruncation.applyTruncation(
              WORDS_THRESHOLD,
              $scope,
              $element
            );
          } else {
            $element.append($scope.text);
          }
        }
      });
    }
  })
};

export const factories = {
  ValidationServices: () => ({
    failIfWrongThreshouldConfig(firstThreshould, secondThreshould) {
      if (
        (!firstThreshould && !secondThreshould) ||
        (firstThreshould && secondThreshould)
      ) {
        throw "You must specify one, and only one, type of threshould (chars or words)";
      }
    }
  }),
  CharBasedTruncation: $compile => ({
    truncationApplies($scope, threshould) {
      return $scope.text.length > threshould;
    },
    applyTruncation(threshould, $scope, $element) {
      if ($scope.useToggling) {
        const el = $(
          "<span>" +
            $scope.text.substr(0, threshould) +
            "<span ng-show='!open'>...</span>" +
            "<span class='btn-link ngTruncateToggleText' " +
            "ng-click='toggleShow()'" +
            "ng-show='!open'>" +
            " " +
            ($scope.customMoreLabel ? $scope.customMoreLabel : "More") +
            "</span>" +
            "<span ng-show='open'>" +
            $scope.text.substring(threshould) +
            "<span class='btn-link ngTruncateToggleText'" +
            "ng-click='toggleShow()'>" +
            " " +
            ($scope.customLessLabel ? $scope.customLessLabel : "Less") +
            "</span>" +
            "</span>" +
            "</span>"
        );
        $compile(el)($scope);
        $element.append(el);
      } else {
        $element.append($scope.text.substr(0, threshould) + "...");
      }
    }
  }),
  WordBasedTruncation: $compile => ({
    truncationApplies($scope, threshould) {
      return $scope.text.split(" ").length > threshould;
    },

    applyTruncation(threshould, $scope, $element) {
      const splitText = $scope.text.split(" ");
      if ($scope.useToggling) {
        const el = $(
          "<span>" +
            splitText.slice(0, threshould).join(" ") +
            " " +
            "<span ng-show='!open'>...</span>" +
            "<span class='btn-link ngTruncateToggleText' " +
            "ng-click='toggleShow()'" +
            "ng-show='!open'>" +
            " " +
            ($scope.customMoreLabel ? $scope.customMoreLabel : "More") +
            "</span>" +
            "<span ng-show='open'>" +
            splitText.slice(threshould, splitText.length).join(" ") +
            "<span class='btn-link ngTruncateToggleText'" +
            "ng-click='toggleShow()'>" +
            " " +
            ($scope.customLessLabel ? $scope.customLessLabel : "Less") +
            "</span>" +
            "</span>" +
            "</span>"
        );
        $compile(el)($scope);
        $element.append(el);
      } else {
        $element.append(splitText.slice(0, threshould).join(" ") + "...");
      }
    }
  })
};

export default {
  directives,
  factories
};
